/**
 * useMonitoring Hook - Real Monitoring for Admin Backoffice
 *
 * Centralized polling via Zustand store to avoid duplicate intervals when
 * multiple widgets subscribe in the same page.
 */

import { useEffect } from "react";
import { useMonitoringStore } from "@/shared/stores/monitoringStore";

export type {
    AlertLevel,
    AlertType,
    SystemMetrics,
    Alert,
    AlertSummary,
    ServiceHealth,
} from "@/shared/stores/monitoringStore";

export function useMonitoring() {
    const systemMetrics = useMonitoringStore((s) => s.systemMetrics);
    const alerts = useMonitoringStore((s) => s.alerts);
    const alertsSummary = useMonitoringStore((s) => s.alertsSummary);
    const serviceHealth = useMonitoringStore((s) => s.serviceHealth);
    const isLoading = useMonitoringStore((s) => s.isLoading);
    const error = useMonitoringStore((s) => s.error);
    const resolveAlert = useMonitoringStore((s) => s.resolveAlert);
    const refresh = useMonitoringStore((s) => s.refresh);
    const startPolling = useMonitoringStore((s) => s.startPolling);
    const stopPolling = useMonitoringStore((s) => s.stopPolling);

    useEffect(() => {
        startPolling();
        return () => stopPolling();
    }, [startPolling, stopPolling]);

    return {
        systemMetrics,
        alerts,
        alertsSummary,
        serviceHealth,
        isLoading,
        error,
        resolveAlert,
        refresh,
    };
}
